
import { Options, Vue, prop } from "vue-class-component";

export interface PillSwitchOption {
  label: string;
  value: string | number;
}

class Props {
  modelValue = prop<string | number>({ default: undefined });
  options = prop<PillSwitchOption[]>({ required: true });
}

@Options({
  emits: ["update:modelValue"]
})
export default class PillSwitch extends Vue.with(Props) {}
